import React from "react";
import { useForm } from "react-hook-form";
import Style from "./ChangeDetailProduct.module.css";
import { useState } from "react";

const ChangeDetailProduct = ({ handleClose, rawInfo, sendData }) => {
  const [checked, setChecked] = useState(false);
  const { register, handleSubmit } = useForm();
  const getChecked = (value) => {
    setChecked(value);
  };
  const onSubmit = (data) => {
    sendData({
      product_id: rawInfo.id,
      p_product_id: rawInfo.pProductId === "0" ? 0 : rawInfo.pProductId,
      new_price: data.newPrice === "" ? rawInfo.price : data.newPrice,
      new_count: data.newCount === "" ? rawInfo.count : data.newCount,
      availability: checked ,
    });
    handleClose();
  };
  return (
    <form onSubmit={handleSubmit(onSubmit)} className={Style.modalHolder}>
      <div className={Style.centerHolder}>
        <div
          className={Style.radioPart}
          onChange={(e) => getChecked(e.target.value)}
        >
          <label className={Style.radioInput} for="contactChoice1">
            موجود
            <input
              style={{ marginLeft: ".3rem" }}
              type="radio"
              name="contact"
              value="1"
            />
          </label>

          <label className={Style.radioInput} for="contactChoice2">
            ناموجود
            <input
              style={{ marginLeft: ".3rem" }}
              type="radio"
              name="contact"
              value="0"
            />
          </label>
        </div>
        <input
          {...register("newPrice")}
          className={Style.inputStyle}
          placeholder="قیمت جدید به تومان"
        />
        <input
          {...register("newCount")}
          className={Style.inputStyle}
          placeholder="تعداد جدید"
        />
      </div>
      <div className={Style.btnHolder}>
        <button type={"submit"} className={Style.editBtn}>
          ویرایش
        </button>
      </div>
    </form>
  );
};

export default ChangeDetailProduct;
